<template>
  <section class="w-full px-2 sm:px-4 lg:px-8">
    <div class="flex flex-col gap-6 lg:flex-row lg:gap-[140px]">
      <div class="flex items-start justify-start">
        <div
          class="inline-flex items-center gap-[5px] rounded-[10px] border border-gray-dark p-[15px_20px] text-gray-dark">
          <SvgoIconComponentBIconO class="h-[14px] w-[14px]"></SvgoIconComponentBIconO>
          <span class="text-[14px] font-helvetica font-bold">Объявления</span>
        </div>
      </div>

      <div class="flex-1 divide-y divide-gray-light">
        <template v-if="loading">
          <div v-for="i in 3" :key="i"
            class="flex flex-col gap-4 pb-8 pt-8 first:pt-0 lg:flex-row lg:items-start lg:gap-12 animate-pulse">
            <div class="min-w-[260px] space-y-3">
              <div class="h-4 w-24 rounded bg-gray-light/50" />
              <div class="h-6 w-40 rounded bg-gray-light/60" />
            </div>
            <div class="flex-1 space-y-2">
              <div class="h-4 w-full rounded bg-gray-light/50" />
              <div class="h-4 w-5/6 rounded bg-gray-light/40" />
              <div class="h-4 w-4/6 rounded bg-gray-light/30" />
            </div>
          </div>
        </template>
        <template v-else>
          <Announcement v-for="item in announcements" :key="item.id" :date="item.date" :title="item.title"
            :body="item.body" />
        </template>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import Announcement from "~/components/index/Announcement.vue";
import { useHomeNews } from "~/composables/useHomeNews";

const { announcements, loading, loadNews } = useHomeNews();

onMounted(async () => {
  await loadNews();
});
</script>
